module.exports = __webpack_public_path__ + "static/TMN_background_1-a3be8eaee86839dde93ef61df250feff.jpg";